import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
}

.login-form-panel {
  background: rgba(255, 255, 255, 0.985);
}

.auth-copy {
  word-break: keep-all;
  overflow-wrap: break-word;
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public errorMessage: string = '';
    public errorField: string = '';
    public data: any = { email: '', password: '' };

    public async ngOnInit() {
        await this.service.init();
        const check = await this.service.auth.check();
        if (check) location.href = "/";
    }

    private async showError(message: string, field: string = '') {
        this.errorMessage = message;
        this.errorField = field;
        await this.service.render();
        setTimeout(() => {
            const target = document.getElementById(field || 'login-error');
            target?.focus();
        }, 0);
    }

    public async login() {
        if (this.loading) return;

        const user = JSON.parse(JSON.stringify(this.data));
        user.email = (user.email || '').trim().toLowerCase();
        this.errorMessage = '';
        this.errorField = '';
        if (!user.email) return await this.showError("이메일을 입력해주세요.", "login-email");
        if (!/^[a-z0-9]+(?:[._-][a-z0-9]+)*@[a-z0-9]+(?:-[a-z0-9]+)*(?:\.[a-z0-9]+(?:-[a-z0-9]+)*)+$/.test(user.email)) {
            return await this.showError("올바른 이메일 주소를 입력해주세요.", "login-email");
        }
        if (!user.password) return await this.showError("비밀번호를 입력해주세요.", "login-password");

        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("login", {
                ...user,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code === 200) {
                location.href = "/";
                return;
            }
            await this.showError(data?.message || "로그인에 실패했습니다.");
        } catch (_error) {
            await this.showError("로그인 서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PageAccessComponent;